import React, { useState, useEffect } from 'react';
import { getAnimes } from '../services/animeService';
import AnimeCard from './AnimeCard';
import Loader from './Loader/Loader';
import Pagination from './Pagination';

const AnimeList = ({ searchTerm = '', genreFilter = '', animes: propAnimes = null }) => {
  const [animes, setAnimes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage] = useState(12); // Cantidad de animes por página

  useEffect(() => {
    // Si recibimos animes como prop, los usamos directamente
    if (propAnimes) {
      setAnimes(propAnimes);
      setLoading(false);
      // Ajustamos la paginación (simulada en este caso)
      setTotalPages(Math.ceil(propAnimes.length / itemsPerPage));
      return;
    }

    // Si no hay props, hacemos el fetch normal
    const fetchAnimes = async () => {
      try {
        setLoading(true);
        console.log('AnimeList: Iniciando petición a getAnimes', { currentPage, itemsPerPage, searchTerm });
        
        // Log para ver la URL y las cabeceras
        console.log('API_URL:', process.env.REACT_APP_API_URL || 'http://localhost:4005/api/v1');
        
        const response = await getAnimes(currentPage, itemsPerPage, searchTerm);
        console.log('AnimeList: Respuesta completa de API:', response);
        
        if (response.success) {
          let filteredAnimes = response.data;
          
          // Aplicar filtro de género si se proporciona
          if (genreFilter && genreFilter.trim() !== '') {
            const genreLower = genreFilter.toLowerCase();
            filteredAnimes = filteredAnimes.filter(item => {
              if (typeof item.genre === 'string') {
                return item.genre.toLowerCase().includes(genreLower);
              }
              if (Array.isArray(item.genre)) {
                return item.genre.some(g => g.toLowerCase().includes(genreLower));
              }
              return false;
            });
          }
          
          setAnimes(filteredAnimes);
          
          // Calcular el número total de páginas
          const totalItems = response.pagination?.totalItems || filteredAnimes.length;
          setTotalPages(Math.ceil(totalItems / itemsPerPage));
        } else {
          setError('Error al cargar animes');
          setAnimes([]);
        }
      } catch (err) {
        console.error('Error al obtener animes:', err);
        console.error('Error detallado:', {
          mensaje: err.message,
          status: err.response?.status,
          statusText: err.response?.statusText,
          data: err.response?.data
        });
        setError('Error al cargar animes. Intente nuevamente más tarde.');
        setAnimes([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAnimes();
  }, [currentPage, itemsPerPage, searchTerm, genreFilter, propAnimes]);

  const handlePageChange = (pageNumber) => {
    // Solo cambiar página si no estamos usando animes propios
    if (!propAnimes) {
      setCurrentPage(pageNumber);
      // Scroll hacia arriba cuando se cambia de página
      window.scrollTo(0, 0);
    }
  };

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <div className="text-center text-white my-8">{error}</div>;
  }

  if (animes.length === 0) {
    return <div className="text-center text-white my-8">No hay animes disponibles</div>;
  }

  // Obtener solo los animes para la página actual cuando usamos propAnimes
  const currentAnimes = propAnimes 
    ? propAnimes.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
    : animes;

  return (
    <div className="container mx-auto px-4">
      {/* <h2 className="text-2xl font-bold text-white mb-6">Anime</h2> */}
      
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
        {currentAnimes.map((item) => (
          <AnimeCard key={item.id} anime={item} />
        ))}
      </div>

      {totalPages > 1 && (
        <div className="mt-8 flex justify-center">
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </div>
      )}
    </div>
  );
};

export default AnimeList;
